import { Component, OnInit, Input } from '@angular/core';

import { ImageCroppedEvent } from 'ngx-image-cropper';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';

@Component({
  selector: 'app-pdf-image-uploader',
  templateUrl: './pdf-image-uploader.component.html',
  styleUrls: ['./pdf-image-uploader.component.scss'],
})
export class PdfImageUploaderComponent implements OnInit {
  image: any = null;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageType: any = { 0: 'stretch', 1: 'crop', 2: 'bestFit' };
  company: any = '';
  pdfImg: any = '';
  index = 0;
  selectedTab: number = 1;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private httpService: HTTPService,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    const data = this.dynamicDialogConfig.data;
    if (data && data.file && data.src) {
      this.image = data.file;
      this.pdfImg = data.src;
    }
  }

  closeModal() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  saveImage() {
    this.dynamicDialogRef.close({
      isSuccess: true,
      data: {
        image: this.croppedImage,
        imageType: this.imageType[this.selectedTab],
      },
    });
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
}
